import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { BASE_API_URL, BASE_IMAGE_API_URL } from "../../services/baseServices";
import Swal from "sweetalert2";
import axios from "axios";
import { Select } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function EditProduct({ editObj }) {

  const [formData, setFormData] = useState({
    ProductName: '',
    ProductCode: '',
    Brand: '',
    CategoryName: '',
    Description: ''
  });
  const [image, setImage] = useState(null);
  const { Option } = Select;

  const [submitLoading, setSubmitLoading] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [sessionUserData, setSessionUserData] = useState([]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
        const userData = JSON.parse(userDataString);
        setSessionUserData(userData);
    } else {
        console.log("data not avislable in session");
    }
}, []);

  useEffect(() => {
    if (editObj) {
      setFormData({
        ProductName: editObj.ProductName || '',
        ProductCode: editObj.ProductCode || '',
        Brand: editObj.Brand || '',
        CategoryName: editObj.CategoryName || '',
        Description: editObj.Description || ''
      });
      setSelectedCategoryId(editObj.CategoryId || null);
    }
  }, [editObj]);

  const fetchDDLItems = async (type) => {
    try {
      const response = await axios.get(`${BASE_API_URL}ADMINRoutes/GetDDL?OrgId=9330&UserId=1`);
      const allItems = response.data.ResultData;

      const categoriesResponse = allItems.filter(item => item.DDLName === "Categories");
      setCategoriesData(categoriesResponse);
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
      return null;
    }
  };

  useEffect(() => {
    fetchDDLItems();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const data = new FormData();
    data.append("ProductId", editObj.Id);
    data.append("CategoryId", selectedCategoryId);
    data.append("SubCategoryId", 0);
    data.append("IsActive", 1);
    data.append("UpdatedBy", sessionUserData?.Id);
    for (const key in formData) {
      data.append(key, formData[key]);
    }
    if (image) {
      data.append("ImageUrl", image); // New image selected
    } else {
      data.append("ImageUrl", editObj.ImageUrl); // Use old image URL
    }

    for (let pair of data.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    try {
      const response = await axios.post(
        `${BASE_API_URL}file_upload/EditProduct`,
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      const result = response.data;
      setSubmitLoading(false);
      console.log("Success:", result.output);
      if (result.output.Status === "Success") {
        setSubmitLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Product updated successfully!",
        }).then(() => window.location.reload());
      }
    } catch (error) {
      setSubmitLoading(false);
      console.error("Error uploading product:", error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Failed to update product.",
      });
    }
  };


  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="offcanvasRightEdit"
      aria-labelledby="offcanvasRightLabel"
      style={{ minWidth: "45%", maxWidth: "45%" }}
    >
      <form autoComplete="off" onSubmit={handleSubmit}>
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h5 id="offcanvasRightLabel" className="mb-0">Edit Product</h5>
          <div className="d-flex align-items-center">
            <button
              className="btn btn-primary p-2 rounded w-full me-2"
              type="submit"
              disabled={submitLoading}
            >
              {submitLoading ? 'Submitting...' : 'Submit'}
            </button>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div
          className="offcanvas-body"
          style={{
            minHeight: '33rem',
            overflowY: 'auto',
            paddingBottom: '2rem',
          }}
        >
          <div className="row">
            <div className="col-12 mb-2 col-md-6">
              <label className="form-label">Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="ProductName"
                value={formData.ProductName}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 mb-2 col-md-6">
              <label className="form-label">Code <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="ProductCode"
                value={formData.ProductCode}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 mb-2 col-md-6">
              <label className="form-label">Brand <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="Brand"
                value={formData.Brand}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 mb-2 col-md-6" >
              <label className="form-label">Image <span className="text-danger">*</span></label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={handleImageChange}
              />
            </div>
            <div className="col-6 mb-2 col-md-6" style={{ flex: 1 }}>
              <label className="form-label">Category <span className="text-danger">*</span></label>
              <Select
                showSearch
                allowClear
                placeholder="Choose Category"
                optionFilterProp="children"
                style={{ width: '100%', height: 42 }}
                onChange={(value) => setSelectedCategoryId(value)}
                value={selectedCategoryId} // ← Add this line
                filterOption={(input, option) =>
                  (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {categoriesData && categoriesData.map((item) => (
                  <Option key={item.ItemId} value={item.ItemId}>
                    {item.ItemValue}
                  </Option>
                ))}
              </Select>

            </div>

            <div className="col-12 mb-2">
              <label className="form-label">Description <span className="text-danger">*</span></label>
              <ReactQuill
  theme="snow"
  value={formData.Description}
  onChange={(value) => setFormData((prev) => ({ ...prev, Description: value }))}
/>

            </div>
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Product Image</label>
            <div
              style={{
                width: '100%',
                maxWidth: '350px',
                height: 'auto',
                marginTop: '0.5rem',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                border: '1px solid #ddd',
              }}
            >
              <img
                src={`${BASE_IMAGE_API_URL}${editObj?.ImageUrl}`}
                alt={editObj?.ProductName || 'Product Image'}
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </div>
          </div>
        </div>
      </form>

    </div>
  );
}


EditProduct.propTypes = {
  editObj: PropTypes.object.isRequired,
};

